import styled from 'styled-components';

import type {ChartCardWidth} from '../../types/ChartCardWidth';

// The shapes of the DMS home page tile sizes: full width looks like the wide tile, half width
// like the small tile.
const SHAPE_SIDE = 6;
const SHAPE_GAP = 1;
const SHAPE_CELLS = [
  {column: 1, row: 1},
  {column: 2, row: 1},
  {column: 1, row: 2},
  {column: 2, row: 2},
];
const FILLED_COLUMNS: Record<ChartCardWidth, number> = {full: 2, half: 1};

const StyledShape = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: ${({theme}) => theme.getSize(SHAPE_GAP)};
  width: ${({theme}) => theme.getSize(SHAPE_SIDE)};
  height: ${({theme}) => theme.getSize(SHAPE_SIDE)};
`;

const StyledShapeCell = styled.div<{$isFilled: boolean}>`
  border-radius: ${({theme}) => theme.radii.xSmall};
  background: ${({theme, $isFilled}) =>
    $isFilled ? theme.colors.palettes.blue[80][100] : theme.colors.palettes.neutral[70][40]};
`;

interface ChartWidthShapeProps {
  width: ChartCardWidth;
}

export function ChartWidthShape(props: ChartWidthShapeProps) {
  return (
    <StyledShape aria-hidden>
      {SHAPE_CELLS.map((cell) => (
        <StyledShapeCell
          key={`${cell.column}x${cell.row}`}
          $isFilled={cell.row === 1 && cell.column <= FILLED_COLUMNS[props.width]}
        />
      ))}
    </StyledShape>
  );
}
